import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'
import getRequestParams from '@/helpers/getRequestParams.js'

export const useCarEventsSubsStore = defineStore('carEventsSubs', () => {
    const configStore = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore = useTokenStore()

    const carEventsSubs = ref({})
    const carEventsSubsProcess = ref(false)
    const carEventsSubsMsg = ref({})

    const carEventSubsProcess = ref(false)
    const carEventSubsMsg = ref({})

    async function createCarEventsSubs(payload) {
        const token = tokenStore.access

        if (token) {
            carEventSubsProcess.value = true

            let carUuid = ''

            if (payload.carUuid) {
                carUuid = payload.carUuid
                delete payload.carUuid
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/events/params/manyV2/${carUuid}`,
                method: 'POST',
                token,
                data: payload
            })
            if (!request.error) {
                carEventSubsMsg.value = { success: true, text: 'EVENTS_SUBS_CREATE_SUCCESS' }
            } else {
                carEventSubsMsg.value = { success: false, text: request.error }
            }

            carEventSubsProcess.value = false
        } else {
            carEventSubsMsg.value = { success: false, text: 'EUnauthRequest' }
        }
    }

    async function readCarEventsSubs(payload) {
        const token = tokenStore.access

        if (token) {
            carEventsSubsProcess.value = true

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/events/params?uuid_car_array=${payload}`,
                method: 'GET',
                token
            })

            if (!request.error) {
                carEventsSubs.value = request
                carEventsSubsMsg.value = { success: true }
            } else {
                carEventsSubs.value = {}
                carEventsSubsMsg.value = { success: false, text: request.error }
            }

            carEventsSubsProcess.value = false
        } else {
            carEventsSubsMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        return carEventsSubs.value
    }

    async function deleteCarEventsSubs(payload) {
        const token = tokenStore.access

        if (token) {
            carEventSubsProcess.value = true

            let carUuid = ''

            if (payload.carUuid) {
                carUuid = payload.carUuid
                delete payload.carUuid
            }

            const params = getRequestParams(payload)

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/events/params/many/${carUuid}${params}`,
                method: 'DELETE',
                token
            })

            if (!request.error) {
                carEventSubsMsg.value = { success: true, text: 'EVENTS_SUBS_DELETE_SUCCESS' }
            } else {
                carEventSubsMsg.value = { success: false, text: request.error }
            }

            carEventSubsProcess.value = false
        } else {
            carEventSubsMsg.value = { success: false, text: 'EUnauthRequest' }
        }
    }

    return {
        carEventsSubs,
        carEventsSubsProcess,
        carEventsSubsMsg,
        carEventSubsProcess,
        carEventSubsMsg,
        createCarEventsSubs,
        readCarEventsSubs,
        deleteCarEventsSubs
    }
})
